module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-900.a35f0f1c.ttf";